import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Col, Row, Card, Container, Breadcrumb, Table, Badge, Form } from 'react-bootstrap';
import { InputTextarea } from "primereact/inputtextarea";
import { getSocket } from '../context/socket'; // adjust path as needed
import axios from "axios";
import { useAuth } from '../context/AuthContext';
import config from '../config';
import DOMPurify from "dompurify";
const New_description = ({ description, cardId }) => {
    const [value, setValue] = useState('');
    const [editing, setEditing] = useState(false);
    const socket = getSocket();
    const [showDetails, setShowDetails] = useState(() => {
        const stored = localStorage.getItem("cardShowDetails");
        const parsed = stored ? JSON.parse(stored) : {};
        return parsed[cardId] !== undefined ? parsed[cardId] : true;
    });
    

    const toggleDetails = () => setShowDetails(prev => !prev);

    useEffect(() => {
        const stored = localStorage.getItem("cardShowDetails");
        const parsed = stored ? JSON.parse(stored) : {};
        parsed[cardId] = showDetails;
        localStorage.setItem("cardShowDetails", JSON.stringify(parsed));
    }, [showDetails, cardId]);
    

    useEffect(() => {
        setValue(description || ''); // Initialize with the prop
    }, [description]);

    const handleSave = () => {
        if (!cardId) return;
        socket.emit("editCardDescription", {
            card_id: cardId,
            description: value
        });
        setEditing(false); // after saving, exit edit mode
    };

    const handleCancel = () => {
        setValue(description || ''); // reset back to original
        setEditing(false);
    };

    const handleEdit = () => {
        setEditing(true);
    };

    // Sanitize + convert newlines to <br />
    const getSafeHtml = (raw) => {
        const withLineBreaks = raw.replace(/\n/g, "<br />");
        return DOMPurify.sanitize(withLineBreaks);
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-start">
                <h6><i className="pi pi-align-left me-2"></i> <b>Description</b></h6>
                <div>
                    <Button
                        tooltip={showDetails ? "Hide Details" : "Show Details"}
                        icon={showDetails ? "pi pi-eye-slash" : "pi pi-eye"}
                        className="p-0 border-0"
                        text
                        style={{ width: '30px' }}
                        severity="secondary"
                        onClick={toggleDetails}
                    />

                    {!editing && (
                        <Button
                            tooltip="Edit"
                            icon="pi pi-pencil"
                            className="p-0 border-0"
                            text
                            severity="secondary"
                            onClick={handleEdit}
                        />
                    )}
                </div>
            </div>
            <div>
                {!editing && showDetails && (
                    <p
                        className="mb-0 text-muted"
                        dangerouslySetInnerHTML={{ __html: `<small>${getSafeHtml(value)}</small>` }}
                    />
                )}
                {editing && (
                    <>
                        <InputTextarea
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            rows={5}
                            cols={30}
                            className="w-100 mt-2 h-auto"
                            disabled={!editing} // make it readonly unless editing
                        />
                        <span className="d-flex justify-content-start">
                            <Button
                                label="Save"
                                severity="primary"
                                className="border-0 py-1 px-3 mt-3 me-2"
                                onClick={handleSave}
                            />
                            <Button
                                label="Cancel"
                                text
                                severity="secondary"
                                className="border-0 py-1 px-3 mt-3"
                                onClick={handleCancel}
                            />
                        </span>
                    </>
                )}
            </div>
        </>
    );
};

export default New_description;